import React from "react";
import { TooltipContent } from "src/components/ui/tooltip";

export interface PermissionItem {
  label: string;
  allowed: boolean;
}

interface NoPermissionTooltipProps {
  permissions: PermissionItem[];
  align?: "end" | "start" | "center";
}

const NoPermissionTooltip: React.FC<NoPermissionTooltipProps> = ({
  permissions,
  align,
}) => {
  return (
    <TooltipContent align={align ?? "start"} className="bg-[#F7F6DE] text-xs">
      <p className="mb-3 font-semibold">
        You don't have permission to access this feature
      </p>

      {permissions.length > 0 && (
        <div>
          <p>Permissions missing:</p>
          <ul className="list-disc ml-4 mt-2">
            {permissions.map((p) => (
              <li key={p.label}>{p.label}</li>
            ))}
          </ul>
        </div>
      )}
    </TooltipContent>
  );
};

export default NoPermissionTooltip;
